import { LevelsFilter } from "../../../operations/filters/levels.js";
import { GLProgram } from "../../../program.js";
export class LevelsProgram extends GLProgram {

    constructor(gl: any, vertex_source: any, fragment_source: any) {
        super(gl, vertex_source, fragment_source);
    }

    static create(templates, gl) {
        var common_source = templates.get('photoshop/GL/shaders/common.glsl');
        var vertex_source = templates.get('photoshop/GL/shaders/filters/levels/vertex.glsl');
        var fragment_source = templates.get('photoshop/GL/shaders/filters/levels/fragment.glsl');
        var result = new LevelsProgram(gl, vertex_source, common_source + fragment_source);
        result._uniforms['texture'] = gl.getUniformLocation(result._program, 'u_texture');
        result._uniforms['texture_size'] = gl.getUniformLocation(result._program, 'u_texture_size');
        result._uniforms['input'] = gl.getUniformLocation(result._program, 'u_input');
        result._uniforms['output'] = gl.getUniformLocation(result._program, 'u_output');
        result._uniforms['gamma'] = gl.getUniformLocation(result._program, 'u_gamma');
        result._uniforms['use_selection'] = gl.getUniformLocation(result._program, 'u_use_selection');
        result._uniforms['selection_mask'] = gl.getUniformLocation(result._program, 'u_selection_mask');
        return result;
    }

    setUniforms(parameters: LevelsFilter) {
        var self = this;
        self._gl.uniform2f(self.uniformLocation('texture_size'), parameters._width, parameters._height);
        self._gl.uniform2f(self.uniformLocation('input'), parameters.inputMin / 255, parameters.inputMax / 255);
        self._gl.uniform2f(self.uniformLocation('output'), parameters.outputMin / 255, parameters.outputMax / 255);
        self._gl.uniform1f(self.uniformLocation('gamma'), parameters.exponent);
    }

}